module.exports = __webpack_public_path__ + "static/media/icon-clock-svg-white.32ddce5e.svg";